module.exports = __webpack_public_path__ + "images/grupo_IDDrive.dd7b5e88.png";